import clsx from 'clsx';
import type { LinksFunction } from '@remix-run/node';
import type { FC } from 'react';

import { Link } from '@remix-run/react';

import type { SharedAnchorProps } from './shared-anchor.types';

import styles from './shared-anchor.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

export const SharedAnchor: FC<SharedAnchorProps> = ({
  children,
  className = '',
  intent = 'primary',
  isNewTab = false,
  href,
  path,
  ...rest
}) => {
  const classes = clsx('shared-anchor', className, {
    'shared-anchor--primary': intent === 'primary',
    'shared-anchor--secondary': intent === 'secondary',
    'shared-anchor--tertiary': intent === 'tertiary',
    'shared-anchor--quaternary': intent === 'quaternary',
    'shared-anchor--inverted': intent === 'inverted',
  });

  const newTabProps = isNewTab
    ? { rel: 'noopener noreferrer', target: '_blank' }
    : {};

  const anchorProps = {
    className: classes,
    ...newTabProps,
  };

  if (href) {
    return (
      <a href={href} {...anchorProps} {...rest}>
        {children}
      </a>
    );
  }

  if (path) {
    return (
      <Link to={path} {...anchorProps} {...rest}>
        {children}
      </Link>
    );
  }

  throw new Error('Anchor component must have either href or path prop');
};
